import { render, staticRenderFns } from "./StudioList.vue?vue&type=template&id=3a7bbdfa&"
import script from "./StudioList.vue?vue&type=script&lang=js&"
export * from "./StudioList.vue?vue&type=script&lang=js&"
import style0 from "./StudioList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports